// API Configuration
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8090',
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000, // 1 second
};

// Helper function to create fetch with timeout
export const fetchWithTimeout = (url, options = {}) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_CONFIG.TIMEOUT);

    return fetch(url, {
        ...options,
        signal: controller.signal
    }).finally(() => {
        clearTimeout(timeoutId);
    });
};

// Helper function to retry fetch requests
export const fetchWithRetry = async (url, options = {}, maxRetries = API_CONFIG.RETRY_ATTEMPTS) => {
    let lastError;
    
    for (let attempt = 0; attempt < maxRetries; attempt++) {
        try {
            const response = await fetchWithTimeout(url, options);
            return response;
        } catch (error) {
            lastError = error;
            console.warn(`Fetch attempt ${attempt + 1}/${maxRetries} failed:`, error.message);
            
            if (attempt < maxRetries - 1) {
                // Wait before retrying (exponential backoff)
                const delay = API_CONFIG.RETRY_DELAY * Math.pow(2, attempt);
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    }
    
    throw lastError;
};